import React, { lazy } from 'react';

import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';

import type { CustomizationExtensionProps as UiProps } from './CustomizationExtension';

export type CustomizationExtensionProps = UiProps;

const LazyCustomizationExtension = lazy(
    () =>
        import(
            /* webpackChunkName: 'customization-extension' */
            './CustomizationExtension'
        ),
);

/**
 * Lazy loaded version of CustomizationExtension
 * @param CustomizationExtensionProps
 * @returns CustomizationExtension
 */
export const CustomizationExtension: React.FC<CustomizationExtensionProps> = (props) => (
    <Suspense>
        <LazyCustomizationExtension {...props} />
    </Suspense>
);

CustomizationExtension.displayName = 'Extension';
